import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/store';

const selectAdminFaq = (state: RootState) => state.adminFaq;

/** Every category in display order, each with its questions in order. */
export const selectAdminFaqCategories = (state: RootState) => selectAdminFaq(state).categories;
export const selectAdminFaqLoadStatus = (state: RootState) => selectAdminFaq(state).loadStatus;
/** Writes that ended and await the page's reaction (see `MutationOutcome`). */
export const selectAdminFaqOutcomes = (state: RootState) => selectAdminFaq(state).outcomes;
export const selectAdminFaqLastDeleted = (state: RootState) => selectAdminFaq(state).lastDeleted;
/** Client searches that found nothing (#735), most searched first. */
export const selectAdminFaqSearchMisses = (state: RootState) => selectAdminFaq(state).searchMisses;
/** A dismiss to offer Undo for, or a failure to toast; cleared once shown. */
export const selectAdminFaqSearchMissNotice = (state: RootState) =>
  selectAdminFaq(state).searchMissNotice;

/**
 * The three tiles. A question counts by its own flag: a published question in a
 * hidden category is still "published" (it shows as soon as the category does).
 */
export const selectAdminFaqStats = createSelector(selectAdminFaqCategories, (categories) => {
  let published = 0;
  let drafts = 0;
  for (const category of categories) {
    for (const question of category.questions) {
      if (question.is_published) published += 1;
      else drafts += 1;
    }
  }
  return { categories: categories.length, published, drafts };
});

/** Category picker of the question dialog and the "Move to…" submenu. */
export const selectAdminFaqCategoryOptions = createSelector(
  selectAdminFaqCategories,
  (categories) =>
    categories.map(({ id, name, is_visible, questions }) => ({
      id,
      name,
      is_visible,
      question_count: questions.length,
    })),
);
